import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../assets/img/accessibility_deaf.svg'
import _imports_1 from '../../../assets/img/accessibility_blind.svg'


const _hoisted_1 = { class: "tv-program-modal__title" }
const _hoisted_2 = { class: "tv-program-modal__description" }
const _hoisted_3 = ["datetime"]
const _hoisted_4 = { class: "tv-program-modal__icon" }
const _hoisted_5 = {
  key: 0,
  class: "tv-program-modal__icon"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Feliratozott"
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "tv-program-modal__icon"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Audio narráció"
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AgeLimit = _resolveComponent("AgeLimit")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, { class: "tv-program-modal" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.programInfo.title), 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("time", {
            datetime: _ctx.programInfo.time
          }, _toDisplayString(_ctx.programInfo.time), 9, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_AgeLimit, {
              "age-limit": +_ctx.programInfo.ageLimit
            }, null, 8, ["age-limit"])
          ]),
          (_ctx.programInfo.subtitled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
            : _createCommentVNode("", true),
          (_ctx.programInfo.audioDescription)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "tv-program-modal__body",
          innerHTML: _ctx.programInfo.body
        }, null, 8, _hoisted_11)
      ])
    ]),
    _: 1
  }))
}